<template>
  <div ref="eventDetail">
    <cw-main>
      <a-row class="row">
        <a-col :lg="16">
          <div>
            <a-row>
              <a-col :lg="10" class="purchase-imgBox">
                <img class="purchase-img" :src="getMelcoI18nLabel(eventConfig, 'coverUrl')" alt="" />
              </a-col>
              <a-col :lg="14" class="purchase-msg-details">
                <div class="title">{{ eventInfo.name }}</div>
                <!-- <div class="status">
                  <span>{{ $t('event-status') }}&nbsp;</span>
                  <span class="status-value">{{ statusObj[eventInfo.status] }}</span>
                </div> -->
                <div class="date">
                  <span>{{ $t('event-date') }}&nbsp;</span>
                  <span>
                    <span
                      class="date-tag"
                      v-for="(item, idx) in eventInfoDate"
                      :key="item"
                    >
                      {{ item
                      }}{{ idx !== eventInfoDate.length - 1 ? ',' : '' }}
                    </span>
                  </span>
                </div>
                <div class="ara">
                  <span>{{ $t('event-venue') }}&nbsp;</span>
                  {{ eventInfo.venue_name }}
                </div>
                <div class="price-container pcBlock">
                  <div class="title">
                    <span class="">{{ $t('ticket-type-title') }}</span>
                    <a-button
                      class="ticket-detail"
                      type="link"
                      icon="file-text"
                      @click="ticketModalVisible = true"
                    >
                      {{ $t('ticket-detail-title') }}
                    </a-button>
                  </div>
                  <div
                    class="price-desc-item"
                    v-for="item in ticketTypes"
                    :key="item.id"
                  >
                    <template v-if="selectTicketMap.hasOwnProperty(item.id)">
                      <div class="price-desc-title">
                        {{ item.name }}
                      </div>
                      <a-select
                        style="width: 120px"
                        v-model="selectTicketMap[item.id]"
                        size="large"
                      >
                        <a-select-option
                          v-for="number in ((eventConfig.quantityLimit + 1) || 0)"
                          :key="number"
                          :value="number - 1"
                        >
                          {{ number - 1 }}
                        </a-select-option>
                      </a-select>
                    </template>
                  </div>
                </div>
              </a-col>
            </a-row>
            <a-row v-if="eventConfig && getMelcoI18nLabel(eventConfig, 'termsAndConditions')">
              <!-- <a-col class="info-item">
                <div class="info-title">{{ $t('event-presenter') }}</div>
                <div class="info-desc">
                  {{ getName(info, 'presenterName') }}
                </div>
              </a-col> -->
              <a-col class="info-box">
                <div class="info-desc" :class="showMore ? 'open' : ''">
                  <div v-html="getMelcoI18nLabel(eventConfig, 'brief')"></div>
                  <div v-html="getMelcoI18nLabel(eventConfig, 'termsAndConditions')"></div>
                </div>
                <template v-if="descToolsVisible">
                  <div class="event-more-detail" v-show="!showMore" @click="showMore = true">
                    <span>{{ $t('event-more-detail') }}</span>
                    <a-icon type="down"/>
                  </div>
                  <div class="event-less-detail" v-show="showMore" @click="showMore = false">
                    <span>{{ $t('event-less-detail') }}</span>
                    <a-icon type="up"/>
                  </div>
                </template>
              </a-col>
              <!-- <a-col
                class="info-item"
                v-for="(item, index) in eventInfo.descriptions || []"
                :key="index"
              >
                <div class="info-title">{{ getName(item, 'title') }}</div>
                <div class="info-desc" v-html="getName(item, 'content')"></div>
              </a-col> -->
            </a-row>
          </div>
        </a-col>
        <a-col v-if="eventDates && eventDates.length > 0" :lg="8" class="asideBox">
          <div class="aside" width="100%">
            <div class="purchase-buy">
              <select-date
                :dateList="eventDates"
                @clickDate="clickDate"
                :defaultDateId="choosePerfId"
                :name="eventInfo.name"
              ></select-date>
              <div class="title">
                <div class="price-name">{{ $t('price-title') }}</div>
                <div class="price-btn-wrap">
                  <a-button
                    v-for="item in showPriceList"
                    :key="item.id + '-' + item.price_id"
                    class="card-button"
                  >
                    {{ item.citylinePrice }}
                  </a-button>
                </div>
                <div class="price-tip">{{ $t('priceTip') }}</div>
              </div>

              <div class="price-container mobileBlock">
                <div class="title">
                  <span class="">{{ $t('ticket-type-title') }}</span>
                  <a-button
                    class="ticket-detail"
                    type="link"
                    icon="file-text"
                    @click="ticketModalVisible = true"
                  >
                    {{ $t('ticket-detail-title') }}
                  </a-button>
                </div>
                <div
                  class="price-desc-item"
                  v-for="item in ticketTypes"
                  :key="item.id"
                >
                  <template v-if="selectTicketMap.hasOwnProperty(item.id)">
                    <div class="price-desc-title">
                      {{ item.name }}
                    </div>
                    <a-select
                      style="width: 120px"
                      v-model="selectTicketMap[item.id]"
                      size="large"
                    >
                      <a-select-option
                        v-for="number in 9"
                        :key="number"
                        :value="number - 1"
                      >
                        {{ number - 1 }}
                      </a-select-option>
                    </a-select>
                  </template>
                </div>
              </div>
              <div class="ticketCard">
                <a-button type="primary" @click="handleClickBuy">
                  {{ $t('purchase-title') }}
                </a-button>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
    </cw-main>

    <!-- 门票详情 -->
    <a-modal
      class="ticketModal"
      width="90%"
      centered
      :getContainer="() => $refs.eventDetail"
      :title="$t('ticket-discount-details-title')"
      :visible="ticketModalVisible"
      @cancel="ticketModalVisible = false"
      :footer="null"
    >
      <div class="tableBox">
        <table>
          <thead>
            <tr>
              <td>{{ $t('price-zone-title') }}</td>
              <td>{{ $t('type-code-title') }}</td>
              <td>{{ $t('description-title') }}</td>
              <td>{{ $t('price-title') }}</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in priceList" :key="item.id">
              <td>{{ item.name }}</td>
              <td>
                <p v-for="ticket in item.ticket_types" :key="ticket.id">
                  {{ ticket.name }} /
                  {{ ticket.price_model }}
                </p>
              </td>
              <td>
                <div
                  v-for="ticket in item.ticket_types"
                  :key="ticket.id"
                  v-html="ticket.description"
                  class="htmlBox"
                ></div>
              </td>
              <td>
                <p v-for="ticket in item.ticket_types" :key="ticket.id">
                  HK${{ ticket.citylinePrice }}
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { isLoginApi } from '@/api/melco'
import cwMain from '@/components/container/cw-main'
import selectDate from '@/components/selectDate'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  components: {
    cwMain,
    selectDate
  },
  data () {
    return {
      priceList: [],
      eventId: this.$route.query.event,
      choosePerfId: null,
      selectTicketMap: {},
      ticketModalVisible: false,
      showMore: false,
      descToolsVisible: false,
      ticketCategories: []
    }
  },
  computed: {
    ...mapState(['eventInfo', 'eventConfig', 'eventDates', 'isLogin']),
    ...mapGetters(['getMelcoI18nLabel']),
    eventInfoDate () {
      if (!this.eventInfo.sessions) {
        return []
      }
      return this.eventInfo.sessions.map(item => item.dateIso)
    },
    ticketTypes () {
      const result = []
      this.priceList.forEach(item => {
        item.ticket_types.forEach(ticketItem => {
          if (!result.find(resultItem => resultItem.id === ticketItem.id)) {
            result.push(ticketItem)
          }
        })
      })
      return result
    },
    showPriceList () {
      const arr = []
      this.priceList.forEach(item => {
        item.ticket_types.forEach(subItem => {
          if (!arr.find(arrItem => arrItem.citylinePrice === subItem.citylinePrice)) {
            arr.push(subItem)
          }
        })
      })
      return arr.sort((a, b) => b.citylinePrice - a.citylinePrice)
    }
  },
  watch: {
    ticketTypes: {
      handler () {
        this.selectTicketMap = {}
        this.ticketTypes.forEach((item) => {
          this.$set(this.selectTicketMap, item.id, 0)
        })
        console.log(this.selectTicketMap)
      },
      deep: true,
      immediate: true
    },
    eventConfig: {
      handler () {
        this.$nextTick(() => {
          const infoDescBox = document.querySelector('.info-desc')
          if (infoDescBox && infoDescBox.scrollHeight > 120) {
            this.descToolsVisible = true
          } else {
            this.descToolsVisible = false
          }
        })
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    this.setSelectTicketType()
    this.cancelReserve(false)
    this.choosePerfId = Number(this.$route.query.perfId)
    if (this.eventInfo.id && Number(this.eventInfo.id) !== Number(this.eventId)) {
      this.resetMelcoInfo()
    }
    this.initMelcoEvent(this.eventId).then(() => {
      if (this.eventDates && this.eventDates.length > 0) {
        this.clickDate(this.eventDates[0])
      }
    })
  },
  methods: {
    ...mapMutations(['resetMelcoInfo', 'setSelectTicketType']),
    ...mapActions(['initMelcoEvent', 'cancelReserve']),
    clickDate (date) {
      this.choosePerfId = date.id
      this.ticketCategories = date.ticketCategories
      this.priceList = date.category_qty_data.map(subItem => {
        return this.ticketCategories.find(categoryItem => categoryItem.id === subItem.category.id)
      }).filter(subItem => subItem)
    },
    async handleClickBuy () {
      if (process.env.NODE_ENV !== 'development') {
        const res = await isLoginApi()
        if (!['1', 1].includes(res)) {
          window.location.href = this.$cwLink + '/Login.do?targetUrl=' + encodeURIComponent(window.location.href)
          return
        }
      }
      const ticketQuery = {}
      let total = 0
      for (const [key, value] of Object.entries(this.selectTicketMap)) {
        if (value > 0) {
          total += value
          ticketQuery[key] = value
        }
      }
      if (this.eventConfig.quantityLimit < total) {
        this.$error({
          title: this.$t('max.ticket.type.error', { maxQuantity: this.eventConfig.quantityLimit }),
          closable: true,
          okText: this.$t('app-btn-confirm'),
          class: 'maxQuantityBox'
        })
        return
      }

      this.setSelectTicketType(ticketQuery)
      this.$router.push({
        name: 'Performance',
        query: {
          event: this.eventId,
          perfId: this.choosePerfId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
}
.asideBox {
  @media (max-width: 991px) {
    margin: 0 -16px;
    @include background_color('white-background');
  }
}
.aside {
  padding: 0 5%;
  @media (max-width: 991px) {
    margin: 0 auto;
    @include background_color('white-background');
    padding: 0.9375rem 15px 0;
  }
}

.purchase-imgBox {
  @media (max-width: 991px) {
    margin: 0 -16px;
  }
  .purchase-img {
    width: 15rem;
    @media (max-width: 991px) {
      width: 100%;
    }
  }
}

.purchase-msg-details {
  padding-left: 3rem;
  @include font_color('detail-info');

  @media (max-width: 991px) {
    padding: 0;
  }

  > div {
    font-size: 1.125rem;
    margin-top: 1.875rem;
    @media (max-width: 991px) {
      font-size: 0.75rem;
      margin-top: 0.75rem;
    }
  }

  .title {
    margin-top: 0;
    font-size: 1.875rem;
    @include font_color('detail-title');
    font-weight: 500;
    line-height: 1.2;
    @media (max-width: 991px) {
      font-size: 1.3125rem;
    }
  }

  .date-tag {
    display: inline-block;
    margin-right: 5px;
  }

  .like {
    font-size: 1.3125rem;
  }

  .status-value {
    @include font_color('detail-status');
  }
}
.price-container {
  display: none;
  text-align: left;
  width: 100%;
  .title {
    display: flex;
    align-items: center;
    font-size: 1.25rem;
    font-weight: 700;
    .ticket-detail {
      display: flex;
      align-items: center;
      padding: 0 4px;
      font-size: 1.125rem;
      line-height: 1;
      color: #5577ff;
    }
    @media (max-width: 991px) {
      font-size: 0.875rem;
      .ticket-detail {
        font-size: 0.75rem;
        span {
          margin-left: 4px;
        }
      }
    }
  }

  .price-desc-item {
    font-size: 1rem;
    @include font_color('detail-title');

    .price-desc-title {
      margin: 10px 0 5px;
    }
    ::v-deep .ant-select-selection {
      border: 1px solid #6979f8;
      padding: 0 0.75rem;

      .ant-select-selection__rendered {
        margin-left: 0;
      }
      .ant-select-arrow {
        color: #6979f8;
      }
    }
  }
}

.info-item {
  margin-top: 12px;
  @include font_color('detail-info');
  font-size: 1rem;

  .info-title {
    font-weight: bold;
  }
}

.purchase-buy {
  > div {
    padding: 0 5px;
    @media (max-width: 991px) {
      padding: 0;
    }
  }

  .title {
    @include font_color('detail-buy_title');
    font-size: 1.3125rem;
    font-weight: 700;
    @media (max-width: 991px) {
      font-size: 0.875rem;
    }
    .price-name {
      margin-bottom: 2px;
    }
  }

  .price-btn-wrap {
    display: flex;
    flex-wrap: wrap;
    margin: -0.5%;

    .card-button {
      position: relative;
      width: 32%;
      height: auto;
      margin: 0.5%;
      padding: 6px;
      display: flex;
      justify-content: center;
      white-space: initial;
      font-size: 1.3125rem;
      color: #465aba;
      border: 0.125rem solid #465aba;
      @include border_color('detail-buy_border');
      background-color: transparent;
      cursor: default;
      &::after {
        display: none;
      }

      /* &:hover {
        border-color: #007bff;
        @include border_color('detail-buy_border-hover');
        @include background_color('detail-buy_background-active');
      } */

      /* &:focus {
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
      } */

      /* &.active {
        @include background_color('detail-buy_background-active');
      } */

      /* &:disabled {
        opacity: 0.65;
      } */

      @media (max-width: 991px) {
        // width: 24%;
        width: 97.5%;
        font-size: 1rem;
        display: inline-block;
        margin: 0.625rem 0.5%;
        padding: 0;
        height: 2.375rem;
        line-height: 1.5;
      }
    }
    .limited-img {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0.125rem;
      width: 1.25rem;
      height: 1.25rem;
      background: #f2c94c;
      padding: 3px;
      border-radius: 1rem;
    }
    @media (max-width: 991px) {
      display: grid;
      flex-wrap: wrap;
      gap: 2px;
      grid-template-columns: repeat(4, 1fr);
      margin: 0;
    }
  }

  .price-tip {
    margin-top: 4px;
    font-size: 1rem;
    @include font_color('performance-title');
    font-weight: 400;
    @media (max-width: 991px) {
      margin-bottom: 10px;
    }
  }

  .ticketCard {
    margin: 45px 20px 0;
    // padding: 20px;
    // @include background_color('detail-tick_card_background');

    @media (max-width: 991px) {
      // margin: 45px 0;
      background-color: transparent !important;
      padding: 20px;
      margin: 0;
      margin-top: 45px;
    }

    .ant-btn {
      width: 100%;
      height: 2.9375rem;
      font-size: 1.125rem;
      border-radius: 0.3125rem;
      border: none;
      background: linear-gradient(90deg, #46baee 0%, #999dff 100%);
    }
  }
}

.ticketModal {
  .tableBox {
    width: 100%;
    overflow: auto;
  }
  table {
    margin-bottom: 80px;
    width: 100%;
    border-collapse: collapse;
    @media (max-width: 991px) {
      margin-bottom: 20px;
    }

    thead td {
      height: 56px;
      font-size: 1.3125rem;
      font-weight: 700;
      padding: 0 24px;
      @include font_color('detail-info');
      @include background_color('ticketModal-table-head-bgc');
      &:nth-child(n + 2) {
        border-left: 1px solid #fff;
      }
    }

    tbody td {
      padding: 13px 24px;
      border-bottom: 1px solid #c4c4c4;
      font-size: 1.125rem;
      @include font_color('ticketModal-table-color');

      p {
        margin: 5px 0;
        white-space: nowrap;
      }

      ::v-deep .htmlBox {
        p {
          margin: 5px 0;
          white-space: nowrap;
        }
      }
    }

    @for $i from 1 through 10 {
      tbody tr:nth-child(#{$i}) td:first-child {
        background-color: rgb(
          calc(#{$i} * 9 + 205),
          calc(#{$i} * 9 + 205),
          calc(#{$i} * 9 + 205)
        );
        border: none;
      }
    }
  }
}
[data-theme='black'] .ticketModal table {
  @for $i from 1 through 10 {
    tbody tr:nth-child(#{$i}) td:first-child {
      background-color: #000;
    }
  }
}

.info-box {
  margin-top: 20px;
  .info-desc {
    @include font_color('detail-info');
    @media (max-width: 991px) {
      max-height: 120px;
      overflow: hidden;
      &.open {
        max-height: none;
      }
    }
  }
  .event-more-detail,
  .event-less-detail {
    margin: 20px 0;
    display: none;
    font-size: 0.75rem;
    color: #6979f8;
    i {
      margin-left: 5px;
    }
    @media(max-width: 991px) {
      display: flex;
      align-items:center;
      justify-content: center;
    }
  }
}

::v-deep .info-box .info-desc {
  img,
  video {
    max-width: 100%;
  }
}
</style>
